import React from "react";
//#region types
import { SimpleTimelineProps } from "models/propTypes/chartProps";
import { timelineItemClasses } from "@mui/lab/TimelineItem";
//#endregion
//#region components
import Timeline from "@mui/lab/Timeline";
import TimelineStep from "./step";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const SimpleTimeline: React.FC<SimpleTimelineProps> = ({ items }) => {
  const stepCount = items.length;
  const lastStepIndex = stepCount - 1;
  return stepCount ? (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
      className={cssExports.timeline}
    >
      {items.map((item, index) => (
        <TimelineStep
          key={index}
          item={item}
          isLastStep={index === lastStepIndex}
          nextStepType={items[index + 1]?.type}
        />
      ))}
    </Timeline>
  ) : (
    <></>
  );
};

export default SimpleTimeline;
